// extracted by mini-css-extract-plugin
export var card = "TrailDetailsCard-module__card___JBbif";
export var backgroundImage = "TrailDetailsCard-module__backgroundImage___Q2fE1";
export var content = "TrailDetailsCard-module__content___rO6ek";
export var name = "TrailDetailsCard-module__name___fVfrR";
export var starRatingWrapper = "TrailDetailsCard-module__starRatingWrapper___jZfTb";
export var reviewCount = "TrailDetailsCard-module__reviewCount___gHSrk";
export var location = "TrailDetailsCard-module__location___xmmiJ";
export var badge = "TrailDetailsCard-module__badge___B7o_D";
export var favorite = "TrailDetailsCard-module__favorite___uOAwW";
export var flex = "TrailDetailsCard-module__flex___FpMmc";
export var clickable = "TrailDetailsCard-module__clickable___zOWO5";